import React, { useState, useEffect } from 'react';
import MasterPage from 'components/MasterPage';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Row, Col, Form, Button, Card } from 'react-bootstrap';
import ListingStatuses from 'components/ListingStatuses';
import style from './style.module.scss';
import { api } from 'services';
import Can from 'components/Can';
import { DashboardOutlined } from '@material-ui/icons';

const MarketingPlanList = () => {
  const defaultFilters = { page: 1, __search: '', per_page: 10 };

  const [data, setData] = useState({ data: [] });
  const [filters, setFilters] = useState(defaultFilters);
  const [steps, setSteps] = useState([]);

  useEffect(() => {
      api.get('flows/2/marketing-plans-count').then(({ data }) => {
        setSteps(data.steps);
      });
  }, []);

  useEffect(() => {
      api
        .get('marketing-plans', { params: { ...filters } })
        .then(({ data }) => {
          setData({
            ...data, data: [...data.data.map(dt => {
              dt.total_value = dt.currency_id === 1 ? dt.total_value_real : dt.total_value;
              return dt;
            })]
          });
        });
  }, [filters]);

  const { t } = useTranslation();

  const handleFilterChange = (new_filters, reset = false) => {
    if(new_filters.search){
      new_filters.__search = new_filters.search;
    }
    delete new_filters.search;
    let f = { ...filters, ...new_filters };

    if (reset) f = { ...defaultFilters, ...new_filters };

    setFilters(f);
  };

  return (
    <Card.Body className="shadow bg-white rounded mb-3">
      <section className={style.calendar}>
        <Row>
          <Col className="d-flex mt-3 mb-3">
            <DashboardOutlined className="icon-title" />
            <h4 className="title-dashboard mt-2">{t('title:plan list')}</h4>
          </Col>
        </Row>
        <Row>
          <Col md={3}>
            <Form.Group>
              <Form.Label style={{ display: 'block' }}>&nbsp;</Form.Label>
              <Can do="createPlan" on="App">
                <Button
                  size="sm"
                  className="login-btn mr-1 ml-4"
                  variant="primary-login"
                  as={Link}
                  to="/marketing-plans/create"
                >
                  <i className="fas fa-plus"></i> {t('label:add new')}
                </Button>
              </Can>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col>
            <ListingStatuses
              data={data}
              statuses={steps.map((step) => ({
                ...step.status,
                ...{ count: step.marketing_plans_count },
              }))}
              setFilters={setFilters}
              stateFilters={filters}
              filters={[]}
              fields={[
                { name: '#', key: 'id', type: 'string' },
                { name: 'name', key: 'name', type: 'string' },
                { name: 'company', key: 'company_alias', type: 'string' },
                { name: 'start date', key: 'delivery_date', type: 'date' },
                { name: 'end date', key: 'approval_date', type: 'date' },
                {
                  name: 'period',
                  type: 'custom',
                  value: (flatten, dt) =>
                    `${dt.period_type_name} ${dt.period_position}`,
                },
                {
                  name: 'value',
                  key: 'total_value',
                  type: 'currency mask'
                },
                { name: 'analyst', key: 'user_name', type: 'string' },
              ]}
              actions={[
                (marketing_plan, k) => (
                  <Can do="editPlan" on="App">
                    <Button
                      size="sm"
                      variant="light"
                      key={k}
                      as={Link}
                      to={`marketing-plans/edit/${marketing_plan.id}`}
                    >
                      <i className="fas fa-pen" />
                    </Button>
                  </Can>
                ),
              ]}
              handleFilterChange={handleFilterChange}
            />
          </Col>
        </Row>
      </section>
    </Card.Body>
  );
};

export default MasterPage(MarketingPlanList);
